import * as React from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import AddressInput from 'modules/core/components/AddressInput'
import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import { companyLegalEntities } from 'modules/core/store/collections/legalEntities'

import type AddressForm from 'modules/billing/lib/forms/PersonalForm'
import CompanyIdentification from 'modules/settings/components/CompanyIdentification'
import type IdentificationForm from 'modules/settings/lib/forms/Identification'

interface Props {
  addressForm: AddressForm
  identificationForm: IdentificationForm
  legalEntityForm: Form
}

const BillingInfoStep = ({ addressForm, identificationForm, legalEntityForm }: Props) => {
  const entities = companyLegalEntities(companies.current)

  const options = React.useMemo<SelectOption[]>(
    () =>
      entities.map((le) => ({
        label: le.attributes.legal_name,
        value: le.attributes.id,
      })),
    [entities]
  )

  return (
    <>
      {entities.length > 1 && (
        <FormRow>
          <Select
            label={i18n.t('common.legal_entity')}
            options={options}
            field={legalEntityForm.get('legal_entity_id')}
          />
        </FormRow>
      )}
      <CompanyIdentification form={identificationForm} />
      <AddressInput form={addressForm} />
    </>
  )
}

export default observer(BillingInfoStep)
